import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-subscriber-shell',
  templateUrl: './subscriber-shell.component.html',
  styleUrls: ['./subscriber-shell.component.less'],
  standalone: false,
})
export class SubscriberShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
